import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { LogOut, Eye, Sun, Moon } from "lucide-react";
import { useTheme } from "next-themes";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const isDark = theme === "dark";
  return (
    <Button
      data-testid="theme-toggle"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      variant="ghost"
      size="icon"
      aria-label={isDark ? "Aydınlık moda geç" : "Karanlık moda geç"}
      className="h-9 w-9 text-neutral-600 dark:text-neutral-300 hover:text-neutral-950 dark:hover:text-white"
    >
      {mounted && isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}

export default function Header() {
  const { logout, isViewer } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-white/90 dark:bg-neutral-950/90 backdrop-blur-md border-b border-neutral-200 dark:border-neutral-800">
      <div className="max-w-6xl mx-auto px-4 min-h-[3.5rem] py-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5 min-w-0">
          <Logo className="h-9 w-9 sm:h-10 sm:w-10 shrink-0" />
          <div className="min-w-0">
            <div className="font-heading font-semibold text-[12.5px] sm:text-[15px] leading-tight text-neutral-950 dark:text-neutral-50 line-clamp-2">
              Mobilya Toptan ve Perakende Komitesi
            </div>
            <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.12em] text-neutral-500 dark:text-neutral-400 mt-0.5">
              Seçmen Takip
            </div>
          </div>
          {isViewer && (
            <span
              data-testid="viewer-badge"
              className="hidden sm:inline-flex ml-2 items-center gap-1 text-[10px] uppercase tracking-wider font-semibold bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 border border-neutral-200 dark:border-neutral-700 px-2 py-1 rounded-full"
            >
              <Eye className="h-3 w-3" />
              Görüntüleyici
            </span>
          )}
        </div>
        <div className="flex items-center gap-1 shrink-0">
          {isViewer && (
            <span className="sm:hidden text-[10px] font-semibold uppercase tracking-wider bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 px-2 py-1 rounded-full flex items-center gap-1">
              <Eye className="h-3 w-3" />
              Bakış
            </span>
          )}
          <ThemeToggle />
          <Button
            data-testid="logout-btn"
            onClick={logout}
            variant="ghost"
            size="sm"
            className="h-9 gap-1.5 text-neutral-600 dark:text-neutral-300 hover:text-neutral-950 dark:hover:text-white"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Çıkış</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
